var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35678 18.7878H13.6386C13.1568 19.7584 12.1557 20.4286 10.9985 20.4286C9.8414 20.4286 8.84034 19.7584 8.35678 18.7878Z",
    fill: "#1B1B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8543 16.6958C18.8543 17.4542 18.2384 18.0701 17.48 18.0701H4.51715C3.75872 18.0701 3.14282 17.4542 3.14282 16.6958C3.14282 16.2937 3.31758 15.9119 3.62299 15.6506C4.81747 14.6411 5.49954 13.1735 5.49954 11.6193V9.42884C5.49954 6.59535 7.65266 4.25559 10.4098 3.96037V2.16186C10.4098 1.8361 10.6728 1.57141 10.9986 1.57141C11.3243 1.57141 11.5873 1.8361 11.5873 2.16186V3.96037C14.3444 4.25559 16.4976 6.59535 16.4976 9.42884V11.6193C16.4976 13.1735 17.1796 14.6411 18.3656 15.6456C18.6795 15.9119 18.8543 16.2937 18.8543 16.6958Z",
    fill: "#1B1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.38ba20e6f4ab0e29532e081396b50f2e.svg";
export { ForwardRef as ReactComponent };